import { render, staticRenderFns } from "./SchoolService.vue?vue&type=template&id=3ba31dbf&scoped=true&"
import script from "./SchoolService.vue?vue&type=script&lang=ts&"
export * from "./SchoolService.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolService.vue?vue&type=style&index=0&id=3ba31dbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba31dbf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow,VSpacer})
